import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import { TABLET } from '@streamr/streamr-layout/styled'
import Address from './Address'
import { Box, List, Item } from './Selector.styled'
import useToggle from '~hooks/useToggle'

const UnstyledSelector = ({ className, items, selected, onSelect }) => {
    const [open, toggle] = useToggle(false)

    const rootRef = useRef()

    useEffect(() => {
        const onGlobalClick = ({ target }) => {
            const { current: root } = rootRef

            if (!root || !root.contains(target)) {
                toggle(false)
            }
        }

        document.addEventListener('mousedown', onGlobalClick)

        return () => {
            document.removeEventListener('mousedown', onGlobalClick)
        }
    }, [toggle])

    return (
        <div ref={rootRef} className={className}>
            <Box
                onClick={() => {
                    toggle()
                }}
            >
                <Address value={selected} />
            </Box>
            <List visible={open}>
                {items.map((item) => (
                    <li key={item}>
                        <Item
                            onClick={() => {
                                if (typeof onSelect === 'function') {
                                    onSelect(item)
                                }
                                toggle(false)
                            }}
                        >
                            <Address value={item} />
                        </Item>
                    </li>
                ))}
            </List>
        </div>
    )
}

const Selector = styled(UnstyledSelector)`
    color: #323232;
    flex-basis: 50%;
    overflow: visible;
    position: relative;

    & + & {
        margin-left: 16px;
    }

    @media (min-width: ${TABLET}px) {
        flex-basis: auto;
    }
`

export default Selector
